var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPrint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    stroke: "current",
    viewBox: "0 0 140 140",
    height: 140,
    width: 140,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.833333333333333,0,0,5.833333333333333,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 19.499L16.5 19.499",
    fill: "none",
    stroke: "current",
    strokeWidth: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 16.499L16.5 16.499",
    fill: "none",
    stroke: "current",
    strokeWidth: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5,16.5h-3a2.006,2.006,0,0,1-2-2v-6a2.006,2.006,0,0,1,2-2h19a2.006,2.006,0,0,1,2,2v6a2.006,2.006,0,0,1-2,2h-3",
    fill: "none",
    stroke: "current",
    strokeWidth: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5,4.5V.5h9.586a1,1,0,0,1,.707.293l2.414,2.414a1,1,0,0,1,.293.707V4.5",
    fill: "none",
    stroke: "current",
    strokeLinecap: "round",
    strokeWidth: "current",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5,22.5a1,1,0,0,1-1,1H6.5a1,1,0,0,1-1-1v-9h13Z",
    fill: "none",
    stroke: "current",
    strokeWidth: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.500 9.499 A1.000 1.000 0 1 0 4.500 9.499 A1.000 1.000 0 1 0 2.500 9.499 Z",
    fill: "none",
    stroke: "current",
    strokeWidth: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 0.499L14.5 4.499 18.5 4.499",
    fill: "none",
    stroke: "current",
    strokeWidth: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrint);
export default __webpack_public_path__ + "static/media/icon-print.c6c46bed.svg";
export { ForwardRef as ReactComponent };